<template>
  <TvaModal :show="show" @onClose="$emit('onClose')">
    <article class="country-modal">
      <img
        v-if="smallscreen"
        :src="`${$baseUrl}images/${imagePath}.webp`"
        alt=""
        class="country-modal__img"
      />
      <CountrySideBar
        :cardSubscript="cardSubscript"
        :countryCode="countryCode"
        :smallscreen="smallscreen"
      />
      <CountryContent
        :title="title"
        :content="content"
        :countryCode="countryCode"
        :projectAmount="projectAmount"
        :currentProjectIndex="currentProjectIndex"
        :imagePath="imagePath"
        :smallscreen="smallscreen"
        @onNavigate="$emit('onNavigate', $event)"
      />
    </article>
  </TvaModal>
</template>

<script setup>
import { computed, inject } from "vue";
import useTvaMq from "@/plugins/tvaMq.js";

import TvaModal from "./TvaModal.vue";
import CountrySideBar from "./CountrySideBar.vue";
import CountryContent from "./CountryContent.vue";

defineProps({
  show: Boolean,
  cardSubscript: String,
  countryCode: String,
  title: String,
  imagePath: String,
  content: Object,
  projectAmount: Number,
  currentProjectIndex: Number,
});

const $baseUrl = inject("$baseUrl");
const { $tvaMq } = useTvaMq();
const smallscreen = computed(() => ["tablet", "mobile"].includes($tvaMq.value));
</script>

<style lang="scss" scoped>
.country-modal {
  width: 100vw;
  height: calc(var(--vh) * 100);
  background-color: var(--white-100);

  .desktop &,
  .large & {
    display: flex;
  }

  .mobile &,
  .tablet & {
    padding-top: toRem(52);
    overflow: scroll;
  }

  &__img {
    width: 100%;
    height: 25%;
    object-fit: cover;
  }

  > :first-child {
    .desktop &,
    .large & {
      width: 30%;
    }
  }

  > :last-child {
    .desktop &,
    .large & {
      width: 70%;
    }
  }
}
</style>
